import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import {returnEmptyIfNull} from 'utils/string-utils';
import * as constants from '../constants/course-evaluation-template-edit-summary-action-types';

import type {Map} from 'immutable';

export type CourseEvaluationTemplateEditSummaryStore = {
    evaluationTemplate: Map<unknown, unknown>;
};

const initialState = () => {
    return {
        evaluationTemplate: Immutable.Map(),
    };
};

const actionsMap = {
    [constants.GET_EVALUATION_TEMPLATE_SUCCESS]: (state, action) => {
        return {
            evaluationTemplate: returnEmptyIfNull(action.data, ['description']),
        };
    },
    [constants.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CourseEvaluationTemplateEditSummaryStore>(initialState(), actionsMap);
